import { useLocation } from "react-router-dom";

import useRoutes from "./useRoutes";

type Routes = ReturnType<typeof useRoutes>["routes"];

const useCurrentPageDetails = () => {
  const { pathname } = useLocation();
  const { routes } = useRoutes();

  return findCurrentRoute(pathname, routes);
};

export default useCurrentPageDetails;

// First match wins, in this order: the exact url, then the create or edit leaf under it, then
// any page the pathname merely sits beneath. Falls back to the root route, so the caller always
// gets a route object.
const findCurrentRoute = (pathName: string, routes: Routes) => {
  let result: any = false;

  Object.keys(routes).forEach(routeName => {
    if (result) {
      return;
    }

    const currentRoute = routes[routeName];
    const isExactPage = pathName === currentRoute?.url;

    if (isExactPage) {
      result = currentRoute;
    }

    if (!result && currentRoute?.create?.url === pathName) {
      result = currentRoute.create;
    }

    if (!result && currentRoute?.edit?.url === pathName) {
      result = currentRoute.edit;
    }

    if (!result && currentRoute.url !== routes.root.url && pathName.includes(currentRoute?.url)) {
      result = currentRoute;
    }
  });

  return result || routes.root;
};
